export const OPEN_ORDER_DRAWER_SCAN_ACTION_NAME = 'open_order_drawer';
export const REDIRECT_AND_OPEN_ORDER_DRAWER_SCAN_ACTION_NAME = 'redirect_and_open_order_drawer';
export const SUBMIT_ORDER_DRAWER_SCAN_ACTION_NAME = 'submit_order_drawer';
export const SUBMIT_ORDER_DETAILS_PAGE_ACTION_NAME = 'submit_order_details_page';
export const SCAN_ACTION_FAILURE_ACTION_NAME = 'scan_action_failure';
